<div [formGroup]="parentForm" [class.ms-xlarge-b]="displayMargin">
  <div class="relative ps-xxsmall-b">
    <label class="grey-600-text text-icon-secondary font-body-medium" [for]="idOrControlName">
      {{ translationPrefix + '.label' | finLocalization }}
      @if (isRequired) {
        <span> *</span>
      }
    </label>
    <select
      class="has-initial-value font-body-medium"
      [formControlName]="controlName"
      [id]="idOrControlName"
      [name]="controlName"
      [attr.aria-required]="isRequired"
      #selectElement
    >
      <option value selected disabled>{{ selectLabelTranslationKey | finLocalization }}</option>
      @for (option of options; track option.value) {
        <option [value]="option.value" [disabled]="option.disabled" class="font-body-medium">
          {{ option.name ? option.name : (translationPrefix + '.' + option.value | finLocalization) }}
        </option>
      }
    </select>
    <span class="divider"></span>
  </div>
  @if (ctrlField.invalid && ctrlField.touched) {
    <div class="error-label font-body-small" aria-live="polite">
      @if (ctrlField.errors?.required) {
        <span class="error-900-text signal-error-notification-border-icon-text">
          {{ translationPrefix + '.required' | finLocalization }}
        </span>
      }
    </div>
  }
</div>
